/**
 * 从URL里面获取列表
 */
export var getKeyFromUrl = function (key) {
    var reg = new RegExp("(^|&)".concat(key, "=([^&]*)(&|$)"), 'i');
    var r = window.location.search.substr(1).match(reg);
    return r ? unescape(r[2]) : null;
};
